import { render, staticRenderFns } from "./BestOfferConfigurationDialog.vue?vue&type=template&id=2936f522&scoped=true"
import script from "./BestOfferConfigurationDialog.vue?vue&type=script&lang=js"
export * from "./BestOfferConfigurationDialog.vue?vue&type=script&lang=js"
import style0 from "./BestOfferConfigurationDialog.vue?vue&type=style&index=0&id=2936f522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2936f522",
  null
  
)

export default component.exports